var _rect, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideoConference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 3.5,
    width: 15,
    height: 12,
    rx: 0.5,
    stroke: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M7 16h6v2H7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 2,
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2V14H7v-1.5Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoConference);
export default ForwardRef;